import * as actionTypes from "../../actions/actionTypes";

const initialState = {
    listing: {},
    isEnableConciergeService: true,
    countData: {
        newMessagesCount: 0,
        newSubscriptionRequestCount: 0,
        activePatientSubscriptionCount: 0,
    },
};

const concierge = (state = { ...initialState }, action) => {
    switch (action.type) {
        case actionTypes.SET_SUBSCRIBED_CONCIERGE_SERVICE_LIST:

            if (action.data?.links?.current > 1) {
                state.listing.results.push(...action.data.results);
                state.listing.links = {...action.data?.links}
                return state;
            }

            return {
                ...state,
                listing: action.data, 
            };

        case actionTypes.SET_CLEAR_MESSSAGE_NOTIFICATION_DOT:
            if (state.listing?.results) {
                const dataId = action.payload?.id;

                const updatedResults = state.listing.results.map((elem) =>
                    elem.id === dataId
                        ? { ...elem, unread_message_count: 0 }
                        : elem
                );

                state.listing.results = updatedResults
                return state

            }
            return state;
        
        case actionTypes.SET_CHAT_MESSAGES_COUNT:
            state.countData.newMessagesCount = action.payload?.data?.unread_messages_count;
            state.countData.newSubscriptionRequestCount = action.payload?.data?.new_subscription_request_count;

            return state;

        case actionTypes.SET_ACTIVE_PATIENT_SUBSCRIPTION_COUNT:
            state.countData.activePatientSubscriptionCount = action.payload?.data?.active_patients_count;

            return state;
        
        case actionTypes.SET_CONCIERGE_SERVICE_STATUS:
            state.isEnableConciergeService = action.payload?.data?.concierge_service;

            return state;

        default:
            return state;
    }
};

export default concierge;
